import { createAction, props } from '@ngrx/store';
import { User } from './entity-usuarios.model';

export const entityUserLoadRequest = createAction(
  '[ENTITYUSER] Load Request'
);

export const entityUserLoadFailure = createAction(
  '[ENTITYUSER] Load Failure',
  props<{ error: Error }>()
);

export const entityUserLoadSuccess = createAction(
  '[ENTITYUSER] Load Success',
  props<{ items: User[] }>()
);
